import ChromeDropdown from 'components/ChromeDropdown/ChromeDropdown.react';
import Field from 'components/Field/Field.react';
import Label from 'components/Label/Label.react';
import Modal from 'components/Modal/Modal.react';
import React from 'react';
import { SpecialClasses } from 'lib/Constants';
import TextInput from 'components/TextInput/TextInput.react';

function validClassName(name) {
  return !!name.match(/^[a-zA-Z][_a-zA-Z0-9]*$/);
}

export default class CreateClassDialog extends React.Component {
  constructor() {
    super();
    this.state = {
      type: 'Custom',
      name: '',
    };

    this.handleKey = this.handleKey.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
  }

  componentDidMount() {
    document.body.addEventListener('keydown', this.handleKey);
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKey);
  }

  onCloseClick() {
    this.props.onCancel();
  }

  handleKey(e) {
    const keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.onCloseClick(this);
        break;
    }
  }

  valid() {
    if (this.state.type !== 'Custom') {
      return true;
    }
    if (this.state.name.length === 0) {
      return false;
    }
    if (!validClassName(this.state.name)) {
      return false;
    }
    if (this.props.currentClasses.indexOf(this.state.name) > -1) {
      return false;
    }
    return true;
  }

  render() {
    const availableClasses = ['Custom'];
    for (const raw in SpecialClasses) {
      if (raw !== '_Session' && this.props.currentClasses.indexOf(raw) < 0) {
        availableClasses.push(SpecialClasses[raw]);
      }
    }

    const typeDropdown = (
      <ChromeDropdown
        value={this.state.type}
        options={availableClasses}
        onChange={type => this.setState({ type, name: '' })} />
    );
    return (
      <Modal
        type={Modal.Types.INFO}
        icon="plus"
        iconSize={40}
        title="Add a new class"
        subtitle="Create a new collection of objects."
        disabled={!this.valid()}
        confirmText="Create class"
        cancelText="Cancel"
        onCancel={this.onCloseClick.bind(this)}
        onConfirm={() => {
          const type = this.state.type;
          const className = type === 'Custom' ? this.state.name : `_${type}`;
          this.props.onConfirm(className);
        }}>
        {availableClasses.length > 1 ?
          <Field
            label={
              <Label
              text="What type of class do you need?" />
          }
            input={typeDropdown} /> : null
        }
        {this.state.type === 'Custom' ?
          <Field
            label={<Label text="What should we call it?" description={'Don\u2019t use any special characters, and start your name with a letter.'} />}
            input={<TextInput placeholder="Give it a good name..." value={this.state.name} onChange={name => this.setState({ name })} />} /> : null
        }
      </Modal>
    );
  }
}
